import React from 'react';
import PropTypes from 'prop-types';
import gaWrapper from 'helpers/analytics/gaWrapper';
import s from './ReadInOtherLanguage.scss';

class ReadInOtherLanguage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggleLangDropDown: false,
    };
    this.toggleLangDropDown = this.toggleLangDropDown.bind(this);
  }
  toggleLangDropDown(event) {
    event.stopPropagation();
    const currToggleLangDropDown = this.state.toggleLangDropDown;
    this.setState({
      toggleLangDropDown: !currToggleLangDropDown,
    });

    gaWrapper(
      'send',
      'event',
      `${this.props.gaCategory}`,
      `read_in_language`,
      ``,
    );
  }
  render() {
    const toggleClass = this.state.toggleLangDropDown ? s.active : '';
    return (
      <div className={`${s.langselector}`} onClick={this.toggleLangDropDown}>
        <span className={`${s.langbtn} ${toggleClass}`}>read in</span>
        <div className={`${s.langdropdown} ${toggleClass}`}>
          {this.props.langData.map(item => (
            <a target="_blank" rel="noopener noreferrer" href={item.wu}>
              {`${item.regName} (${item.engName})`}
            </a>
          ))}
        </div>
      </div>
    );
  }
}

ReadInOtherLanguage.propTypes = {
  langData: PropTypes.arrayOf({}).isRequired,
  gaCategory: PropTypes.string,
};

ReadInOtherLanguage.defaultProps = {
  gaCategory: 'share',
};

export default ReadInOtherLanguage;
